// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dhm-group-detail-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 0;
  overflow: hidden;
}

.dhm-group-detail-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  position: relative;
}

.dhm-group-badge-large {
  background: #002FA7;
  color: white;
  padding: 8px 20px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 24px;
  display: inline-block;
  width: fit-content;
  margin-bottom: 8px;
}

.dhm-group-subtitle {
  font-size: 14px;
  color: #64748b;
}

.dhm-group-detail-header .dhm-modal-delete-btn {
  position: absolute;
  top: 25px;
  right: 24px;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid #8aa3c4b8;
  background: white;
  color: #002FA7;
  white-space: nowrap;
  margin-left: 8px;
}

.dhm-group-detail-header .dhm-modal-delete-btn:hover {
  transform: translateY(-1px);
}

.dhm-group-tabs {
  display: flex;
  gap: 8px;
  margin: 12px 24px 12px 24px;
  padding: 0 18px;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}

.dhm-group-tab {
  padding: 8px 60px;
  background: none;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dhm-group-tab:hover {
  background-color: #f1f5f9;
  color: #002FA7;
}

.dhm-group-tab.active {
  background-color: #002FA7;
  color: white;
}

.dhm-group-detail-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  padding-top: 12px;
}

.dhm-group-main-info {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 12px;
}

.dhm-group-details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.dhm-detail-item {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.dhm-detail-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.dhm-detail-value {
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  line-height: 1.4;
}

.dhm-detail-email {
  font-size: 12px;
  color: #3498db;
  margin-top: 5px;
}

.dhm-choose-curator-btn {
  background: none;
  border: none;
  color: #002FA7;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 0;
  margin-top: 8px;
  text-decoration: underline;
  transition: opacity 0.2s;
}

.dhm-choose-curator-btn:hover {
  opacity: 0.8;
}

.dhm-group-section {
  margin-bottom: 28px;
}

.dhm-section-header-small {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.dhm-section-title {
  font-size: 16px;
  font-weight: 700;
  color: #002FA7;
  margin: 0;
}

.dhm-student-search-container {
  margin-bottom: 16px;
}

.dhm-search-input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  color: #1f2937;
}

.dhm-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.dhm-students-preview {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dhm-all-students {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
}

.dhm-student-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}

.dhm-student-item:hover {
  background-color: #f8f9fa;
}

.dhm-student-item:last-child {
  border-bottom: none;
}

.dhm-student-clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
  margin-bottom: 4px;
  border: 1px solid #e2e8f0;
}

.dhm-student-clickable:hover {
  background-color: #f0f9ff;
  box-shadow: 0 2px 8px rgba(173, 173, 173, 0.1);
  border-color: #002FA7;
}

.dhm-student-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #002FA7;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 15px;
  flex-shrink: 0;
  font-size: 14px;
}

.dhm-student-info {
  flex: 1 1;
  min-width: 0;
}

.dhm-student-name {
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 4px;
  font-size: 14px;
  text-align: left;
}

.dhm-student-contact {
  font-size: 12px;
  color: #64748b;
}

.dhm-student-email,
.dhm-student-phone {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 2px;
}

.dhm-view-all-btn {
  background-color: transparent;
  color: #002FA7;
  border: 1px solid #002FA7;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  margin: 20px auto 0;
  display: block;
  width: fit-content;
}

.dhm-view-all-btn:hover {
  background-color: #7fa3ff4d;
}

.dhm-no-results,
.dhm-no-students {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-style: italic;
}

.dhm-performance-tab {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dhm-subject-selector {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.dhm-select-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.dhm-select-label {
  font-size: 14px;
  font-weight: 500;
  color: #002FA7;
  min-width: 100px;
}

.dhm-subject-select {
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  min-width: 250px;
  background: white;
  cursor: pointer;
}

.dhm-subject-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.dhm-teacher-name {
  font-size: 15px;
  font-weight: 400;
  color: #1f2937;
}

.dhm-teacher-display {
  padding: 8px 0;
}

.dhm-table-container {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  margin-top: 16px;
  position: relative;
}

.dhm-data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 600px;
}

.dhm-data-table thead {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.dhm-data-table th {
  padding: 12px;
  text-align: center;
  font-weight: 600;
  color: #002FA7;
  border-right: 1px solid #e2e8f0;
}

.dhm-data-table th:last-child {
  border-right: none;
}

.dhm-data-table td {
  padding: 10px 12px;
  text-align: center;
  border-bottom: 1px solid #f1f5f9;
  border-right: 1px solid #f1f5f9;
}

.dhm-data-table td:last-child {
  border-right: none;
}

.dhm-data-table th:first-child,
.dhm-data-table td:first-child {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 10;
}

.dhm-data-table thead th:first-child {
  background-color: #f8fafc;
  z-index: 20;
}

.dhm-data-table tbody td:first-child {
  background-color: white;
  font-weight: 500;
  text-align: left;
  position: sticky;
  left: 0;
}

.dhm-student-col {
  width: 230px;
  text-align: left;
}

.dhm-average-col {
  min-width: 80px;
  width: 100px;
  background: #f8fafc;
}

.dhm-date-col {
  min-width: 80px;
  font-size: 0.7rem;
}

.dhm-average-cell {
  text-align: center;
  background: #f8fafc;
}

.dhm-average-badge {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.9em;
  text-align: center;
  min-width: 60px;
  color: white;
}

.dhm-mark-cell {
  text-align: center;
}

.dhm-mark {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  color: white;
}

.dhm-cell-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  font-size: 0.85em;
  transition: all 0.3s ease;
  margin: 0 auto;
  text-align: center;
  line-height: 1;
}

.dhm-status-present {
  background-color: #2cbb00;
}

.dhm-status-absent {
  background-color: #f59e0b;
}

.dhm-status-not {
  background-color: #ef4444;
}

.dhm-status-empty {
  background-color: #d1d5db;
}

.dhm-loading-small {
  text-align: center;
  padding: 40px;
  color: #64748b;
}

.dhm-loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #002FA7;
  border-radius: 50%;
  animation: dhm-spin 1s linear infinite;
  margin-bottom: 16px;
}

.dhm-loading-spinner-small {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #002FA7;
  border-radius: 50%;
  animation: dhm-spin 0.8s linear infinite;
  margin: 0 auto 12px;
}

@keyframes dhm-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.dhm-no-data {
  text-align: center;
  padding: 40px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px dashed #cbd5e1;
}

.dhm-group-detail-loading,
.dhm-group-detail-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  text-align: center;
  padding: 40px;
}

.dhm-error-message {
  color: #e74c3c;
  font-size: 16px;
  margin-bottom: 20px;
}

.dhm-retry-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.dhm-retry-button:hover {
  background-color: #2980b9;
}

.dhm-cache-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  margin: 12px 24px;
  background: rgba(0, 47, 167, 0.1);
  border: 1px solid rgba(0, 47, 167, 0.2);
  border-radius: 20px;
  font-size: 12px;
  color: #002FA7;
  animation: fadeIn 0.3s ease;
  width: fit-content;
}

.dhm-cache-text {
  font-size: 12px;
  font-weight: 500;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}

.sp-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2100;
  animation: sp-fadeIn 0.2s ease;
}

.sp-modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 900px;
  max-height: 85vh;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: sp-slideUp 0.3s ease;
}

@keyframes sp-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes sp-slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@media (max-width: 768px) {
  .dhm-group-detail-header {
    padding: 16px;
  }
  
  .dhm-group-badge-large {
    font-size: 18px;
    padding: 6px 16px;
  }
  
  .dhm-group-detail-header .dhm-modal-delete-btn {
    position: static;
    margin-top: 12px;
    width: 100%;
  }
  
  .dhm-group-tabs {
    margin: 8px 16px;
    padding: 0;
    flex-wrap: wrap;
  }
  
  .dhm-group-tab {
    padding: 6px 24px;
    font-size: 13px;
  }
  
  .dhm-group-detail-body {
    padding: 16px;
  }
  
  .dhm-group-details-grid {
    grid-template-columns: 1fr;
  }
  
  .dhm-select-group {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .dhm-subject-select {
    width: 100%;
    min-width: auto;
  }
  
  .dhm-data-table th,
  .dhm-data-table td {
    padding: 8px;
    font-size: 11px;
  }
  
  .dhm-student-col {
    width: 150px;
  }
  
  .dhm-average-badge {
    padding: 4px 8px;
    font-size: 11px;
    min-width: 45px;
  }
  
  .dhm-mark,
  .dhm-cell-status {
    width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }
  
  .dhm-cache-badge {
    margin: 8px 16px;
    padding: 4px 10px;
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .dhm-group-tab {
    padding: 6px 16px;
    font-size: 12px;
  }
  
  .dhm-student-avatar {
    width: 32px;
    height: 32px;
    font-size: 11px;
    margin-right: 10px;
  }
  
  .dhm-student-name {
    font-size: 13px;
  }
  
  .dhm-student-contact {
    font-size: 11px;
  }
  
  .dhm-view-all-btn {
    padding: 6px 16px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/GroupDetailSectionStyle.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,OAAO;EACP,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".dhm-group-detail-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 0;\n  overflow: hidden;\n}\n\n.dhm-group-detail-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  position: relative;\n}\n\n.dhm-group-badge-large {\n  background: #002FA7;\n  color: white;\n  padding: 8px 20px;\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 24px;\n  display: inline-block;\n  width: fit-content;\n  margin-bottom: 8px;\n}\n\n.dhm-group-subtitle {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.dhm-group-detail-header .dhm-modal-delete-btn {\n  position: absolute;\n  top: 25px;\n  right: 24px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 14px;\n  border: 1px solid #8aa3c4b8;\n  background: white;\n  color: #002FA7;\n  white-space: nowrap;\n  margin-left: 8px;\n}\n\n.dhm-group-detail-header .dhm-modal-delete-btn:hover {\n  transform: translateY(-1px);\n}\n\n.dhm-group-tabs {\n  display: flex;\n  gap: 8px;\n  margin: 12px 24px 12px 24px;\n  padding: 0 18px;\n  align-items: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.dhm-group-tab {\n  padding: 8px 60px;\n  background: none;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dhm-group-tab:hover {\n  background-color: #f1f5f9;\n  color: #002FA7;\n}\n\n.dhm-group-tab.active {\n  background-color: #002FA7;\n  color: white;\n}\n\n.dhm-group-detail-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  padding-top: 12px;\n}\n\n.dhm-group-main-info {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 12px;\n}\n\n.dhm-group-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n.dhm-detail-item {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n}\n\n.dhm-detail-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.dhm-detail-value {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1f2937;\n  line-height: 1.4;\n}\n\n.dhm-detail-email {\n  font-size: 12px;\n  color: #3498db;\n  margin-top: 5px;\n}\n\n.dhm-choose-curator-btn {\n  background: none;\n  border: none;\n  color: #002FA7;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 4px 0;\n  margin-top: 8px;\n  text-decoration: underline;\n  transition: opacity 0.2s;\n}\n\n.dhm-choose-curator-btn:hover {\n  opacity: 0.8;\n}\n\n.dhm-group-section {\n  margin-bottom: 28px;\n}\n\n.dhm-section-header-small {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.dhm-section-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #002FA7;\n  margin: 0;\n}\n\n.dhm-student-search-container {\n  margin-bottom: 16px;\n}\n\n.dhm-search-input {\n  width: 100%;\n  padding: 10px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  background: white;\n  color: #1f2937;\n}\n\n.dhm-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.dhm-students-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dhm-all-students {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px;\n}\n\n.dhm-student-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 15px;\n  border-bottom: 1px solid #f0f0f0;\n  transition: background-color 0.2s;\n}\n\n.dhm-student-item:hover {\n  background-color: #f8f9fa;\n}\n\n.dhm-student-item:last-child {\n  border-bottom: none;\n}\n\n.dhm-student-clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 8px;\n  margin-bottom: 4px;\n  border: 1px solid #e2e8f0;\n}\n\n.dhm-student-clickable:hover {\n  background-color: #f0f9ff;\n  box-shadow: 0 2px 8px rgba(173, 173, 173, 0.1);\n  border-color: #002FA7;\n}\n\n.dhm-student-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #002FA7;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  margin-right: 15px;\n  flex-shrink: 0;\n  font-size: 14px;\n}\n\n.dhm-student-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.dhm-student-name {\n  font-weight: 500;\n  color: #1f2937;\n  margin-bottom: 4px;\n  font-size: 14px;\n  text-align: left;\n}\n\n.dhm-student-contact {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.dhm-student-email,\n.dhm-student-phone {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 2px;\n}\n\n.dhm-view-all-btn {\n  background-color: transparent;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n  padding: 8px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s;\n  margin: 20px auto 0;\n  display: block;\n  width: fit-content;\n}\n\n.dhm-view-all-btn:hover {\n  background-color: #7fa3ff4d;\n}\n\n.dhm-no-results,\n.dhm-no-students {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n  font-style: italic;\n}\n\n.dhm-performance-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.dhm-subject-selector {\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.dhm-select-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.dhm-select-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #002FA7;\n  min-width: 100px;\n}\n\n.dhm-subject-select {\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  min-width: 250px;\n  background: white;\n  cursor: pointer;\n}\n\n.dhm-subject-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.dhm-teacher-name {\n  font-size: 15px;\n  font-weight: 400;\n  color: #1f2937;\n}\n\n.dhm-teacher-display {\n  padding: 8px 0;\n}\n\n.dhm-table-container {\n  overflow-x: auto;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  margin-top: 16px;\n  position: relative;\n}\n\n.dhm-data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  min-width: 600px;\n}\n\n.dhm-data-table thead {\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.dhm-data-table th {\n  padding: 12px;\n  text-align: center;\n  font-weight: 600;\n  color: #002FA7;\n  border-right: 1px solid #e2e8f0;\n}\n\n.dhm-data-table th:last-child {\n  border-right: none;\n}\n\n.dhm-data-table td {\n  padding: 10px 12px;\n  text-align: center;\n  border-bottom: 1px solid #f1f5f9;\n  border-right: 1px solid #f1f5f9;\n}\n\n.dhm-data-table td:last-child {\n  border-right: none;\n}\n\n.dhm-data-table th:first-child,\n.dhm-data-table td:first-child {\n  position: sticky;\n  left: 0;\n  background-color: white;\n  z-index: 10;\n}\n\n.dhm-data-table thead th:first-child {\n  background-color: #f8fafc;\n  z-index: 20;\n}\n\n.dhm-data-table tbody td:first-child {\n  background-color: white;\n  font-weight: 500;\n  text-align: left;\n  position: sticky;\n  left: 0;\n}\n\n.dhm-student-col {\n  width: 230px;\n  text-align: left;\n}\n\n.dhm-average-col {\n  min-width: 80px;\n  width: 100px;\n  background: #f8fafc;\n}\n\n.dhm-date-col {\n  min-width: 80px;\n  font-size: 0.7rem;\n}\n\n.dhm-average-cell {\n  text-align: center;\n  background: #f8fafc;\n}\n\n.dhm-average-badge {\n  display: inline-block;\n  padding: 8px 16px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.9em;\n  text-align: center;\n  min-width: 60px;\n  color: white;\n}\n\n.dhm-mark-cell {\n  text-align: center;\n}\n\n.dhm-mark {\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  color: white;\n}\n\n.dhm-cell-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  color: white;\n  font-weight: 600;\n  font-size: 0.85em;\n  transition: all 0.3s ease;\n  margin: 0 auto;\n  text-align: center;\n  line-height: 1;\n}\n\n.dhm-status-present {\n  background-color: #2cbb00;\n}\n\n.dhm-status-absent {\n  background-color: #f59e0b;\n}\n\n.dhm-status-not {\n  background-color: #ef4444;\n}\n\n.dhm-status-empty {\n  background-color: #d1d5db;\n}\n\n.dhm-loading-small {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n.dhm-loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #002FA7;\n  border-radius: 50%;\n  animation: dhm-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n.dhm-loading-spinner-small {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #002FA7;\n  border-radius: 50%;\n  animation: dhm-spin 0.8s linear infinite;\n  margin: 0 auto 12px;\n}\n\n@keyframes dhm-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.dhm-no-data {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px dashed #cbd5e1;\n}\n\n.dhm-group-detail-loading,\n.dhm-group-detail-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 400px;\n  text-align: center;\n  padding: 40px;\n}\n\n.dhm-error-message {\n  color: #e74c3c;\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n\n.dhm-retry-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.dhm-retry-button:hover {\n  background-color: #2980b9;\n}\n\n.dhm-cache-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  margin: 12px 24px;\n  background: rgba(0, 47, 167, 0.1);\n  border: 1px solid rgba(0, 47, 167, 0.2);\n  border-radius: 20px;\n  font-size: 12px;\n  color: #002FA7;\n  animation: fadeIn 0.3s ease;\n  width: fit-content;\n}\n\n.dhm-cache-text {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-5px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.sp-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2100;\n  animation: sp-fadeIn 0.2s ease;\n}\n\n.sp-modal-content {\n  background: white;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 900px;\n  max-height: 85vh;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  animation: sp-slideUp 0.3s ease;\n}\n\n@keyframes sp-fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes sp-slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n@media (max-width: 768px) {\n  .dhm-group-detail-header {\n    padding: 16px;\n  }\n  \n  .dhm-group-badge-large {\n    font-size: 18px;\n    padding: 6px 16px;\n  }\n  \n  .dhm-group-detail-header .dhm-modal-delete-btn {\n    position: static;\n    margin-top: 12px;\n    width: 100%;\n  }\n  \n  .dhm-group-tabs {\n    margin: 8px 16px;\n    padding: 0;\n    flex-wrap: wrap;\n  }\n  \n  .dhm-group-tab {\n    padding: 6px 24px;\n    font-size: 13px;\n  }\n  \n  .dhm-group-detail-body {\n    padding: 16px;\n  }\n  \n  .dhm-group-details-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .dhm-select-group {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .dhm-subject-select {\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .dhm-data-table th,\n  .dhm-data-table td {\n    padding: 8px;\n    font-size: 11px;\n  }\n  \n  .dhm-student-col {\n    width: 150px;\n  }\n  \n  .dhm-average-badge {\n    padding: 4px 8px;\n    font-size: 11px;\n    min-width: 45px;\n  }\n  \n  .dhm-mark,\n  .dhm-cell-status {\n    width: 28px;\n    height: 28px;\n    line-height: 28px;\n    font-size: 12px;\n  }\n  \n  .dhm-cache-badge {\n    margin: 8px 16px;\n    padding: 4px 10px;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .dhm-group-tab {\n    padding: 6px 16px;\n    font-size: 12px;\n  }\n  \n  .dhm-student-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 11px;\n    margin-right: 10px;\n  }\n  \n  .dhm-student-name {\n    font-size: 13px;\n  }\n  \n  .dhm-student-contact {\n    font-size: 11px;\n  }\n  \n  .dhm-view-all-btn {\n    padding: 6px 16px;\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
